export default __webpack_public_path__ + "static/l5-case4-bf565de7ca0c8d2e2a67c881d5425e8d.jpg";